import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router-dom';
import SideBar from "../commanComponents/sidebar/sidebar";
import React, { useEffect, useState, useRef } from 'react';

import "./profile.css";
import { clearData } from "../../utils/localStorage";
import InfoModel from '../commanComponents/infoModal/infoModal';
import { loadData, saveJsonData } from '../../utils/localStorage';
import PrimaryButton from '../commanComponents/primaryButton/primaryButton';
import TopNavigation from "../commanComponents/topNavigation/topNavigation";
import { getStudentProfileService, editProfileService, LogoutService, getUploadFileUrlService } from "../../modules/services";
import { ROUTES, sidebarNavItems, PROFILE_IMAGE, S3_BUCKET_NAME, S3_REGION, MESSAGE } from "../../constant";


const Profile = () => {
    const navigate = useNavigate();
    const profileImage = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [showLogoutModal, setshowLogoutModal] = useState(false);
    const [data, setData] = useState(false);

    useEffect(() => {

        (async () => {
            const responseData = await getStudentProfileService({});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setData(responseData.data);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();

    }, [navigate]);

    const handleProfileIconClick = () => { 
        profileImage.current.click();
    }

    
    const handleLogoutButton = () => setshowLogoutModal(true);

    const handleCloseLogoutModal = () => setshowLogoutModal(false);

    const handleSaveLogoutModal = () => {
        setIsLoading(true);
        (async () => {
            const responseData = await LogoutService({}, {});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setIsLoading(false);
                clearData();
                window.location.reload();
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    const handleEditButton = () => { 
        navigate(ROUTES.EDIT_PROFILE);
    }

    const handleChangePasswordButton = () => {
        navigate(ROUTES.CHANGE_PASSWORD);
    }

    const uploadProfile = async (file, fileExtension) => {
        setIsLoading(true);
        const imageName = data.id + "_profile_pic_" + Math.floor(Date.now() / 1000) + "." + fileExtension;
        const mediaKey = "profile_images/" + imageName;

        const signedUrlResponse = await getUploadFileUrlService({
            "media_key": mediaKey,
            "content_type": file.type
        }, {});

        if (signedUrlResponse !== "error" && (signedUrlResponse.status_code === 200 || signedUrlResponse.status_code === 201)) {
            const uploadResponse = await fetch(signedUrlResponse.data.signed_url, {
                method: "PUT",
                body: file,
            });
            if (uploadResponse.ok) {
                const profileImageUrl = "https://" + S3_BUCKET_NAME + ".s3." + S3_REGION + ".amazonaws.com/" + mediaKey;
                const editResponse = await editProfileService(data.id, { profile_image: profileImageUrl }, {});
                if (editResponse !== "error" && (editResponse.status_code === 200 || editResponse.status_code === 201)) {
                    setIsLoading(false);
                    var userData = loadData("user");
                    userData = JSON.parse(userData);
                    userData.profile_image = profileImageUrl;
                    setData({ ...data, profile_image: profileImageUrl });
                    saveJsonData("user", userData);
                } else if (editResponse !== "error") {
                    setIsLoading(false);
                } else {
                    clearData();
                    navigate(ROUTES.LOGIN);
                }
            } else {
                toast.error('Failed to upload profile image.');
                setIsLoading(false);
            }
        } else if (signedUrlResponse !== "error") {
            setIsLoading(false);
        } else {
            clearData();
            navigate(ROUTES.LOGIN);
        }
    }

    const handleProfileChange = (e) => { 
        const file = e.target.files[0];
        if (file) {
            const fileExtension = file.name.split(".").pop().toLowerCase();
            if (["png", "jpg", "jpeg"].indexOf(fileExtension) >= 0) {
                uploadProfile(file, fileExtension);
                toast.success(MESSAGE.PROFILE_UPDATED);
            } else {
                toast.error(MESSAGE.UPLOAD_IMAGE_FORMAT_LIMIT);
            }
        }
    }

    return (
        <div className='profile-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.profile} />
            <div className='profile-side-container'>
                {
                    data &&
                    <>
                        <InfoModel
                            show={showLogoutModal}
                            title="Are you sure you want to logout?"
                            handleClose={handleCloseLogoutModal} 
                            saveButtonText="Logout"
                            handleSave={handleSaveLogoutModal}
                        />
                    </>
                }

                <TopNavigation activeItem={sidebarNavItems.profile} />
                
                <div className='row profile-filter-container'>
                    <div className='profile-filter-inner-div'>
                        <PrimaryButton
                            text="Logout"
                            isLoading={isLoading}
                            onClick={handleLogoutButton}
                        />
                    </div>
                </div>
                
                <div className='profile-main-container'>
                    <div className='row'>
                        <div className='col'>
                        <h5>My details</h5>
                        </div>
                        <div className='col profile-header-right'>
                            <PrimaryButton
                                text="Edit"
                                isLoading={isLoading}
                                onClick={handleEditButton}
                            />
                        </div>
                    </div>
                    
                    <hr className="profile-border" />
                    {
                        isLoading ?
                            <div className='academic-courses-loader-div'>
                                <Spinner animation="border" role="status" className='academic-courses-loader'>
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div>
                            :
                            <>
                                <div className='profile-img-div'>
                                    <div className='profile-img-input-div'>
                                        <img
                                            src={data.profile_image ? data.profile_image : PROFILE_IMAGE}
                                            className='profile-img'
                                            alt='profile'
                                        />
                                        <i className="bi bi-camera-fill profile-upload-icon" onClick={handleProfileIconClick}></i>
                                        <input
                                            type='file'
                                            className='profile-input-upload'
                                            ref={profileImage}
                                            onChange={handleProfileChange}
                                        ></input>
                                    </div>
                                    <h5 className='profile-user-name'>{data.first_name} {data.last_name}</h5>
                                </div>
                                <div className='row'>
                                    <div className='col'>
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label className='profile-label'>Email</label>
                                            </div>
                                            <div className='col'>
                                                <label className='profile-value'>{data.email ? data.email :<span>N/A</span>}</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label className='profile-label'>Gender</label>
                                            </div>
                                            <div className='col'>
                                                <label className='profile-value'>{data.gender ? data.gender :<span>N/A</span>}</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label className='profile-label'>Phone no</label>
                                            </div>
                                            <div className='col'>
                                                <label className='profile-value'>{data.phone ? data.phone :<span>N/A</span>}</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label className='profile-label'>State</label>
                                            </div>
                                            <div className='col'>
                                                <label className='profile-value'>{data.state ? data.state :<span>N/A</span>}</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label className='profile-label'>Pin code</label>
                                            </div>
                                            <div className='col'>
                                                <label className='profile-value'>{data.pincode ? data.pincode :<span>N/A</span>}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label className='profile-label'>Gaurdian Name</label>
                                            </div>
                                            <div className='col'>
                                                <label className='profile-value'>{data.guardian_name ? data.guardian_name :<span>N/A</span>}</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label className='profile-label'>Date of Birth</label>
                                            </div>
                                            <div className='col'>
                                                <label className='profile-value'>{data.dob ? data.dob :<span>N/A</span>}</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label className='profile-label'>City</label>
                                            </div>
                                            <div className='col'>
                                                <label className='profile-value'>{data.city ? data.city :<span>N/A</span>}</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label className='profile-label'>Country</label>
                                            </div>
                                            <div className='col'>
                                                <label className='profile-value'>{data.country ? data.country :<span>N/A</span>}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                    }
                </div>
                <div className='profile-main-container'>
                    <h5>Academic Details</h5>
                    <hr className="profile-border" />
                    {
                        isLoading ?
                            <div className='academic-courses-loader-div'>
                                <Spinner animation="border" role="status" className='academic-courses-loader'>
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div>
                            :
                            <div className='row'>
                                <div className='col'>
                                    <div className='row'>
                                        <div className='col-sm-4'>
                                            <label className='profile-label'>School Name</label>
                                        </div>
                                        <div className='col'>
                                            <label className='profile-value'>{data.school ? data.school.name : <span>N/A</span>}</label>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-sm-4'>
                                            <label className='profile-label'>Mentor Name</label>
                                        </div>
                                        <div className='col'>
                                            <label className='profile-value'>{data.mentor_first_name && data.mentor_last_name ? data.mentor_first_name + " " + data.mentor_last_name : <span>N/A</span>}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='row'>
                                        <div className='col-sm-4'>
                                            <label className='profile-label'>Class</label>
                                        </div>
                                        <div className='col'>
                                            <label className='profile-value'>{data.user_class ? data.user_class.name : <span>N/A</span>}</label>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-sm-4'>
                                            <label className='profile-label'>School Location</label>
                                        </div>
                                        <div className='col'>
                                            <label className='profile-value'>{data.school ? data.school.city : <span>N/A</span>}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                </div>
                <div className='profile-main-container'>
                    <div className='row'>
                        <div className='col'>
                            <h5>Change Password</h5>
                        </div>
                        <div className='col profile-header-right'>
                            <PrimaryButton
                                text="Change"
                                isLoading={isLoading}
                                onClick={handleChangePasswordButton}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
 }


export default Profile;
